import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

/** Backend expects MM/DD/YYYY */
function formatDateForInput(value: string | undefined): string {
  if (!value) return "";
  return value.trim();
}

/**
 * As user types, format digits as MM/DD/YYYY and auto-insert slashes.
 * Strips non-digits and limits to 8 digits (MM + DD + YYYY).
 */
function formatDateAsUserTypes(raw: string): string {
  const digits = raw.replace(/\D/g, "").slice(0, 8);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
}

interface DateInputProps {
  value?: string;
  onChange: (value: string) => void;
  label: string;
  required?: boolean;
  id?: string;
  className?: string;
  disabled?: boolean;
  placeholder?: string;
}

export function DateInput({
  value = "",
  onChange,
  label,
  required,
  id,
  className,
  disabled,
  placeholder = "MM/DD/YYYY",
}: DateInputProps) {
  return (
    <div className={cn("space-y-2", className)}>
      <Label htmlFor={id}>
        {label}
        {required && <span className="text-destructive ml-0.5">*</span>}
      </Label>
      <Input
        id={id}
        type="text"
        placeholder={placeholder}
        value={formatDateForInput(value)}
        onChange={(e) => onChange(formatDateAsUserTypes(e.target.value))}
        disabled={disabled}
      />
    </div>
  );
}
